import {Select, SelectOption} from "@rio-cloud/rio-uikit";
import {RequiredConnectedProps} from "./types.ts";
import {useGeneratedId} from "./utils.tsx";
import {useController, useFormContext} from "react-hook-form";
import {useHasViolation} from "./useHasViolation.ts";
import {FormGroup} from "./FormGroup.tsx";
import {ValidationViolation} from "./ValidationViolation.tsx";

type ConnectedSelectProps = RequiredConnectedProps & {
    placeholder?: string;
    options: SelectOption[]
}

export const ConnectedSelect = ({name, placeholder, options, label}: ConnectedSelectProps) => {
    const {control} = useFormContext()
    const id = useGeneratedId(name)
    const {hasViolation, violations} = useHasViolation(name)
    const {field} = useController({name, control})

    return <FormGroup hasViolation={hasViolation}>
        <label htmlFor={id}>{label}</label>
        <Select
            value={[field.value]}
            id={id}
            name={name}
            placeholder={placeholder}
            options={options}
            onChange={selectOption => field.onChange(selectOption?.id)}
        />
        <ValidationViolation violations={violations} />
    </FormGroup>
}